export default "__VITE_ASSET__Cn6Pe5ig__"